import { render, staticRenderFns } from "./MoneyBankAccount.vue?vue&type=template&id=19d52570"
import script from "./MoneyBankAccount.vue?vue&type=script&lang=js"
export * from "./MoneyBankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports